import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import '@babel/polyfill';
import 'whatwg-fetch';
import React, { useEffect } from 'react';
import { render } from 'react-dom';
import { Provider, useDispatch } from 'react-redux';
import { Layout } from '@nackle/paper';
const Content = Layout;
import AppStore from './app-store';
import { bundles } from './app-content';
import { AppRouting } from './app-routing';
import { USER_STORAGE_KEY } from '../constants';
import { setLanguageBundle } from '@nackle/intl-tools';

// Dux
import { setAppLoaded } from './app-dux/app-dux';

import './styles/style.less';

const App = () => {
    const dispatch = useDispatch();
    const setAdditionalInfo = async () => {
        let user = localStorage.getItem( USER_STORAGE_KEY );
        user = user ? JSON.parse( user ) : {};
        const locale = user?.claims?.locale ?? 'en-US';
        await setLanguageBundle( locale, bundles[ locale ] );
        dispatch( setAppLoaded( true ) );
    };

    useEffect( () => {
        setAdditionalInfo();
    }, [] );

    return (
        <Layout className='app-root'>
            <Content className="main-content">
                <AppRouting className="recognize"/>
            </Content>
        </Layout>
    );
};

// eslint-disable-next-line no-undef
Office.initialize = () => {
    render(
        <Provider store={ AppStore }>
            <App/>
        </Provider>,
        document.getElementById( 'app-root' )
    );
};